module.exports = __webpack_public_path__ + "img/stamp.a91646bb.png";